import { render, staticRenderFns } from "./ShareManagement.view.vue?vue&type=template&id=075678e0&scoped=true"
import script from "./ShareManagement.view.vue?vue&type=script&lang=ts"
export * from "./ShareManagement.view.vue?vue&type=script&lang=ts"
import style0 from "./ShareManagement.view.vue?vue&type=style&index=0&id=075678e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075678e0",
  null
  
)

export default component.exports